import { FormInstance } from "antd";

type FieldName = (string | number)[];
type ScrollOptions = Parameters<FormInstance["scrollToField"]>[1];

// Mirrors how antd's scrollToField finds the field's DOM node.
function getFieldNode(formRef: FormInstance, name: FieldName) {
	const instance = formRef.getFieldInstance(name);
	if (instance?.nativeElement instanceof HTMLElement) {
		return instance.nativeElement;
	}
	if (instance instanceof HTMLElement) return instance;
	return document.getElementById(name.join("_"));
}

// Scrolls to a form field unless it is inside something hidden, such as a
// collapsed finding or an inactive report tab. A hidden field has no position,
// so antd would scroll to an arbitrary spot instead. If the field's node can't
// be found, it scrolls as before.
function scrollToFieldIfVisible(
	formRef: FormInstance,
	name: FieldName,
	options?: ScrollOptions
) {
	const node = getFieldNode(formRef, name);
	if (node && node.getClientRects().length === 0) return;
	formRef.scrollToField(name, options);
}

export default scrollToFieldIfVisible;
